<template>
  <div>
    <b-modal id="modalEditCompanies" ref="modalEditCompanies" :title="$t('Companies')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab :title="$t('Company')">
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                  {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_name"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.jur_adress"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.act_adress"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('ITIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.inn"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Reg code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.kpp"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Excutive managers')">
            <b-form-group label-align="right" :label="$t('CEO')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.headman"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Accountant')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.bookeeper"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_headman"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Short name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.short_bookeeper"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Bank')">
            <b-row align-h="center">
              <md-button class="md-raised" @click="showBank">{{ $t('Select bank') }}</md-button>
            </b-row>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.name" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.city" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('BIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.bic" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Correspondent account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="bank.kschet" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Personal account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.account"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Contract')">
            <b-form-group label-align="right" :label="$t('Contract number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.contract_number"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.contract_place"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Number format')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.number_format"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Client prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.client_prefix"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Service place')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.service_place"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditCompanies')" size="lg"/>
      </div>
    </b-modal>

    <b-modal ref="modalBank" size="xl"  hide-footer :title="$t('Bank')">
      <FormBank
      @selectedBank="selectBank"
       @hideFormBank="$bvModal.hide('modalBank')"/>
    </b-modal>
  </div>
</template>

<script>
import FormBank from '@/pages/users/usersAndGroups/detail/additional/formBank'
export default {
  components: {
    FormBank
  },
  props: {
    editItem: null
  },
  data () {
    return {
      banksFields: [
        {key: 'bank_id', label: 'ID', sortable: true},
        {key: 'bic', label: this.$i18n.t('BIN'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true}
      ],
      selectedBank: null,
      bank: {
        bic: '',
        city: '',
        name: '',
        kschet: ''
      }
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      this.editItem.supplier_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_COMPANIES', this.editItem)
        : this.$store.dispatch('Settings/CREATE_COMPANIES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_COMPANIES')
          this.$refs.modalEditCompanies.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id !== 0) {
        if (this.editItem.bank_id !== 0) {
          for (let el of this.banks) {
            if (el.bank_id === this.editItem.bank_id) {
              this.bank.bic = el.bic
              this.bank.city = el.city
              this.bank.name = el.name
              this.bank.kschet = el.kschet
            }
          }
        }
        this.$store.dispatch('Settings/GET_CURRENT_SUPPLIER', this.editItem.id)
      }
    },
    showBank () {
      this.selectedBank = null
      this.$refs.modalBank.show()
    },
    onRowSelected (selected) {
      this.selectedBank = selected[0]
    },
    selectBank (selectedBank) {
      this.editItem.bank_id = selectedBank.bank_id
      this.bank.bic = selectedBank.bic
      this.bank.city = selectedBank.city
      this.bank.name = selectedBank.name
      this.bank.kschet = selectedBank.kschet
      this.$refs.modalBank.hide()
    }
  },
  watch: {
    currentSupplier: function (supplier) {
      this.editItem.contract_number = supplier.contract_number
      this.editItem.contract_place = supplier.contract_place
      this.editItem.number_format = supplier.number_format
      this.editItem.client_prefix = supplier.client_prefix
      this.editItem.service_place = supplier.service_place
    }
  },
  computed: {
    currentSupplier () {
      return this.$store.getters['Settings/CURRENT_SUPPLIER']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/companies/editModal.vue